import React, {useState, useEffect} from 'react'
import {data, urlRoot} from '../utils/data';
import { useStateContext } from '../context/stateContext';
import { Link } from 'react-router-dom';


const Projects = () => {
  const {lightTheme, setLinkHovred} = useStateContext();
  const [showMore,setShowMore]=useState(false);
  const [projects,setProjects]=useState([]);

  useEffect(()=>{
    setProjects(showMore?data.projects:data.projects.slice(0,5))
  }, [showMore])

  return (
    <section className={`projects-section ${lightTheme?"light":"dark"}`} id="projects">
        <div className="container">
          <h2 className='main-heading'>
            My Pro<span>j</span>ects
          </h2>
          <div className="projects">
              {projects.map((project)=>(
                <div className={`project ${lightTheme?"light-shadow":"dark-shadow"}`} key={`prj_${project.id}`} style={{backgroundColor:`${lightTheme?"#fff":"#000"}`}}>
                  <img src={`${urlRoot}${project.img}`} alt="" />
                  <Link
                   to={`/project/${project.id}`}
                   onMouseLeave={()=>setLinkHovred(false)}
                   onMouseEnter={()=>setLinkHovred(true)}
                   style={{backgroundColor:`${lightTheme?"#fff":"#000"}`}}
                  >
                    &gt;_ {project?.title}
                  </Link>
                </div>
              ))}
              <div 
                onMouseLeave={()=>setLinkHovred(false)}
                onMouseEnter={()=>setLinkHovred(true)}
                className={`more project ${lightTheme?"light-shadow":"dark-shadow"}`}
                onClick={()=>{setShowMore(!showMore)}}
              >
                {showMore?'Show Less':'Show More'}
              </div>
          </div>
        </div>
    </section>
  );
}

export default Projects
